import type {RouteLocationNormalized, RouteLocationRaw} from 'vue-router';
import type {Role} from '@afroep/core/domain/role';

export interface SessionView {
  isAuthenticated: boolean;
  role: Role | null;
}

/**
 * Convenience, not security: every endpoint re-checks the caller server side. This only
 * keeps a user from landing on a page they cannot use.
 */
export const resolveNavigation = (
  session: SessionView,
  to: Pick<RouteLocationNormalized, 'meta' | 'fullPath'>,
): RouteLocationRaw | true => {
  if (to.meta.public) {
    return session.isAuthenticated ? {name: 'users'} : true;
  }
  if (!session.isAuthenticated) {
    return {name: 'login', query: {redirect: to.fullPath}};
  }
  const allowed = to.meta.roles;
  if (allowed && session.role && !allowed.includes(session.role)) {
    return {name: 'profile'};
  }
  return true;
};
